/**
 * Internal dependencies.
 */
import edit from './edit';
import metadata from './block.json';
import { GridView as icon } from '../../components/Icons';

/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import { Icon } from '@wordpress/components';

/**
 * Block constants
 */
const { name, category, attributes } = metadata;

const settings = {
	title: __( 'Template Browser' ),
	description: __( 'Browse templates that you have created or pick from Gutenify Libarary.' ),
	icon: <Icon icon={ icon } />,
	keywords: [
		'gutenify',
		__( 'Template' ),
		__( 'Library' ),
		__( 'Templates' ),
		__( 'Browser' ),
	],
	example: {
		attributes: {
		},
	},
	attributes,
	edit,
	save: () => {},
};

export { name, category, settings };
